import { useContext } from 'react';

import { ForterContext } from '../providers/Forter';

export function useForter() {
  const context = useContext(ForterContext);
  if (!context) {
    throw new Error('useForter has to be used within <ForterContext.Provider>');
  }
  return context;
}
